module.exports = __webpack_public_path__ + "img/id_back.92003c5.webp";